import { buildAuthCookieHeader } from "@/lib/auth-cookies";
import { nativeFetch } from "@/lib/capacitor";
import { endpoints } from "muminsmart-utils";
import { getApiBaseUrl } from "./config";
import { ensureValidAccessToken } from "./auth-service";
import { getStoredTokens } from "./auth-storage";

const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer);
  let binary = "";

  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }

  return btoa(binary);
};

export async function requestSellerInvoicesZip(
  startDate: string,
  endDate: string,
  sellerId?: string,
): Promise<{ message: string } | null> {
  const accessToken = await ensureValidAccessToken();
  if (!accessToken) {
    return null;
  }

  const { refreshToken } = await getStoredTokens();
  const params = new URLSearchParams({ startDate, endDate });
  if (sellerId) {
    params.set("sellerId", sellerId);
  }

  const response = await nativeFetch(
    `${getApiBaseUrl()}${endpoints.invoice.sellerZip}?${params.toString()}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Cookie: buildAuthCookieHeader(accessToken, refreshToken) ?? "",
      },
    },
  );

  if (!response.ok) {
    return null;
  }

  return (await response.json()) as { message: string };
}

export async function fetchInvoicePdf(
  id: string,
): Promise<{ data: string; filename: string } | null> {
  const accessToken = await ensureValidAccessToken();
  if (!accessToken) {
    return null;
  }

  const { refreshToken } = await getStoredTokens();
  const response = await nativeFetch(
    `${getApiBaseUrl()}${endpoints.invoice.render(id)}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Cookie: buildAuthCookieHeader(accessToken, refreshToken) ?? "",
      },
      responseType: "arraybuffer",
    },
  );

  if (!response.ok) {
    return null;
  }

  const buffer = await response.arrayBuffer();
  const filename =
    response.headers
      .get("content-disposition")
      ?.match(/filename="?([^"]+)"?/)?.[1] ?? `invoice-${id}.pdf`;

  return { data: arrayBufferToBase64(buffer), filename };
}
